import * as React from 'react';

const SvgIconClose = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-icon="1"
    {...props}>
    <path d="M2 14L14 2" stroke="#A5A5A5" strokeWidth="2" />
    <path d="M14 14L2 2" stroke="#A5A5A5" strokeWidth="2" />
  </svg>
);

export default SvgIconClose;
